<template lang="html">
  <section hero>
    <div class="blur"></div>
    <div class="wrapper">
      <h1>Play, Explore, Discover!</h1>
      <button @click="gogogo()" type="button" class="primary btn"><span class="thin">Schedule</span> Class Trip</button>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    gogogo() {
      window.location = 'https://bookadventure.dsbn.org'
    }
  }
}
</script>

<style lang="less" scoped>
@import '../css/variables';

[hero] {
  position: relative;
  background: url('../assets/crossing.jpg');
  background-size: cover;
  background-position: center 20%;
  overflow: hidden;

  .blur {
    margin: -15px;
    padding: 4em;
    padding-top: 70vh;
    background: url('../assets/crossing.jpg');
    background-size: cover;
    background-position: center 20%;
    -webkit-mask: -webkit-linear-gradient(transparent 50%, black 90%);
    -webkit-mask: linear-gradient(transparent 50%,#000 90%);
    -webkit-filter: blur(5px) brightness(0.5);
  }
  .wrapper {
    position: absolute;
    bottom: 3em;
    left: 2em; right: 2em;
    @media(min-width: @max-width-desktop) {
      left: 4em; right: 4em;
      display: flex;
    }

    h1 {
      flex: 1 0 50%;
      font-size: 3rem;
      font-weight: 100;
      color: rgba(255, 255, 255, 0.88);
      text-shadow: black 0 0.1em 0.4em;
      line-height: 1.5;
    }
    button {
      &:hover {
        background-color: rgba(146,189,120,.9);
        border: 10px solid rgba(119,152,98,.4);
        transform: scale(1.1);
      }

      .thin {
        font-weight: 400;
        font-size: 1.2rem;
        letter-spacing: -0.08em;
      }

      letter-spacing: 0em;
      font-family: Raleway, sans-serif;
      font-weight: 700;
      text-transform: uppercase;
      background-origin: border-box;
      border: 10px solid rgba(119,158,96,.4);
      transition: all ease .2s;
      flex: 0 0 30%;
      background-color: @adventure-primary;
      background-image: url(../assets/topography-light.svg);
      background-size: cover;
      padding: 0.5em 1em 0.6em;
      color: white;
      border-radius: 5px;
      font-size: 1.2rem;
      cursor: pointer;
      @media(min-width: @mobile) {
        padding: 0.25em 0.5em;
        max-width: 350px;
      }
      &:active {
        background-color: darken(@adventure-primary, 15%);
      }
      &:active, &:focus { outline: none; } /* I'm a bad person */
    }
  }
}
</style>



// WEBPACK FOOTER //
// MainHero.vue?0543194c